import FieldsetDescriptionButton from '../FieldsetDescriptionButton/FieldsetDescriptionButton'
import PopOut from '../PopOut/PopOut'
import classes from './InfoPopOut.module.scss'
import type { PopperProps } from 'react-popper'
import type { ReactNode } from 'react'

export interface Props {
  children: ReactNode
  placement?: PopperProps['placement']
  variant?: 'widerWidth' | ''
}

const triggerInfoButton = (ref: any, onClick: () => void) =>
  <FieldsetDescriptionButton
    onClick={onClick}
    ref={ref}
  />

const InfoPopOut = ({
  children,
  placement = 'auto',
  variant = ''
}: Props) =>
  <PopOut
    placement={placement}
    trigger={triggerInfoButton}
  >
    <div className={classes.InfoPopOut + ' ' + classes[variant]}>
      {children}
    </div>
  </PopOut>

export default InfoPopOut
